// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/proposal_reviews.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
/**
 * @generated from message mono.projectdata.v1.ProposalReviewView
 */ export class ProposalReviewView extends Message {
    static fromBinary(bytes, options) {
        return new ProposalReviewView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalReviewView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalReviewView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalReviewView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * YYYY-MM-DD
   *
   * @generated from field: string starts_on = 4;
   */ _define_property(this, "startsOn", ""), /**
   * YYYY-MM-DD or empty
   *
   * @generated from field: string due_on = 5;
   */ _define_property(this, "dueOn", ""), /**
   * @generated from field: repeated string reviewers = 6;
   */ _define_property(this, "reviewers", []), /**
   * empty = every section
   *
   * @generated from field: repeated string scope_section_ids = 7;
   */ _define_property(this, "scopeSectionIds", []), /**
   * open|closed
   *
   * @generated from field: string status = 8;
   */ _define_property(this, "status", ""), /**
   * empty while open; approved|approved_with_changes|not_approved
   *
   * @generated from field: string outcome = 9;
   */ _define_property(this, "outcome", ""), /**
   * @generated from field: string closure_summary = 10;
   */ _define_property(this, "closureSummary", ""), /**
   * @generated from field: string created_by = 11;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string closed_by = 13;
   */ _define_property(this, "closedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp closed_at = 14;
   */ _define_property(this, "closedAt", void 0), /**
   * @generated from field: int32 material_count = 15;
   */ _define_property(this, "materialCount", 0), /**
   * @generated from field: int32 finding_count = 16;
   */ _define_property(this, "findingCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalReviewView, "runtime", proto3);
_define_property(ProposalReviewView, "typeName", "mono.projectdata.v1.ProposalReviewView");
_define_property(ProposalReviewView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "starts_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "reviewers",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "scope_section_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "outcome",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "closure_summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "closed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "closed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "material_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 16,
            name: "finding_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProposalReviewMaterialView
 */ export class ProposalReviewMaterialView extends Message {
    static fromBinary(bytes, options) {
        return new ProposalReviewMaterialView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalReviewMaterialView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalReviewMaterialView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalReviewMaterialView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string review_id = 2;
   */ _define_property(this, "reviewId", ""), /**
   * @generated from field: string section_id = 3;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string section_version_id = 4;
   */ _define_property(this, "sectionVersionId", ""), /**
   * @generated from field: int32 section_version = 5;
   */ _define_property(this, "sectionVersion", 0), /**
   * snapshot_comment is the PROP-07 snapshot's comment (section_versions.comment),
   * so reviewers see why the text was locked.
   *
   * @generated from field: string snapshot_comment = 6;
   */ _define_property(this, "snapshotComment", ""), /**
   * @generated from field: string snapshot_label = 7;
   */ _define_property(this, "snapshotLabel", ""), /**
   * @generated from field: string captured_by = 8;
   */ _define_property(this, "capturedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp captured_at = 9;
   */ _define_property(this, "capturedAt", void 0), /**
   * WRT-30: a DOCX section's material pins a region of an ONLYOFFICE document
   * version instead of a TipTap version (section_version_id is then "").
   *
   * @generated from field: string document_id = 10;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string document_version_id = 11;
   */ _define_property(this, "documentVersionId", ""), /**
   * @generated from field: string anchor_bookmark = 12;
   */ _define_property(this, "anchorBookmark", ""), /**
   * @generated from field: string region_sha256 = 13;
   */ _define_property(this, "regionSha256", ""), /**
   * the region's text at that version, as pinned
   *
   * @generated from field: string region_text = 14;
   */ _define_property(this, "regionText", ""), /**
   * read time from shirohige ("v{n} · {label}"); 0 / "" when unavailable
   *
   * @generated from field: int32 document_version_number = 15;
   */ _define_property(this, "documentVersionNumber", 0), /**
   * @generated from field: string document_version_label = 16;
   */ _define_property(this, "documentVersionLabel", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalReviewMaterialView, "runtime", proto3);
_define_property(ProposalReviewMaterialView, "typeName", "mono.projectdata.v1.ProposalReviewMaterialView");
_define_property(ProposalReviewMaterialView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "section_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "section_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "snapshot_comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "snapshot_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "captured_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "captured_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "document_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "anchor_bookmark",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "region_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "region_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "document_version_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 16,
            name: "document_version_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProposalReviewFindingView
 */ export class ProposalReviewFindingView extends Message {
    static fromBinary(bytes, options) {
        return new ProposalReviewFindingView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalReviewFindingView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalReviewFindingView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalReviewFindingView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string review_id = 2;
   */ _define_property(this, "reviewId", ""), /**
   * @generated from field: string material_id = 3;
   */ _define_property(this, "materialId", ""), /**
   * note|minor|major|critical
   *
   * @generated from field: string severity = 4;
   */ _define_property(this, "severity", ""), /**
   * @generated from field: string body = 5;
   */ _define_property(this, "body", ""), /**
   * @generated from field: string created_by = 6;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalReviewFindingView, "runtime", proto3);
_define_property(ProposalReviewFindingView, "typeName", "mono.projectdata.v1.ProposalReviewFindingView");
_define_property(ProposalReviewFindingView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "material_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "severity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "body",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProposalReviewFields
 */ export class ProposalReviewFields extends Message {
    static fromBinary(bytes, options) {
        return new ProposalReviewFields().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalReviewFields().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalReviewFields().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalReviewFields, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * YYYY-MM-DD
   *
   * @generated from field: string starts_on = 2;
   */ _define_property(this, "startsOn", ""), /**
   * YYYY-MM-DD or empty
   *
   * @generated from field: string due_on = 3;
   */ _define_property(this, "dueOn", ""), /**
   * @generated from field: repeated string reviewers = 4;
   */ _define_property(this, "reviewers", []), /**
   * empty = every section
   *
   * @generated from field: repeated string scope_section_ids = 5;
   */ _define_property(this, "scopeSectionIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalReviewFields, "runtime", proto3);
_define_property(ProposalReviewFields, "typeName", "mono.projectdata.v1.ProposalReviewFields");
_define_property(ProposalReviewFields, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "starts_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reviewers",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "scope_section_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProposalReviewsRequest
 */ export class ListProposalReviewsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalReviewsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalReviewsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalReviewsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalReviewsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalReviewsRequest, "runtime", proto3);
_define_property(ListProposalReviewsRequest, "typeName", "mono.projectdata.v1.ListProposalReviewsRequest");
_define_property(ListProposalReviewsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProposalReviewsResponse
 */ export class ListProposalReviewsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalReviewsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalReviewsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalReviewsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalReviewsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.ProposalReviewView reviews = 1;
   */ _define_property(this, "reviews", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalReviewsResponse, "runtime", proto3);
_define_property(ListProposalReviewsResponse, "typeName", "mono.projectdata.v1.ListProposalReviewsResponse");
_define_property(ListProposalReviewsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reviews",
            kind: "message",
            T: ProposalReviewView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetProposalReviewRequest
 */ export class GetProposalReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProposalReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProposalReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProposalReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProposalReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string review_id = 2;
   */ _define_property(this, "reviewId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProposalReviewRequest, "runtime", proto3);
_define_property(GetProposalReviewRequest, "typeName", "mono.projectdata.v1.GetProposalReviewRequest");
_define_property(GetProposalReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetProposalReviewResponse
 */ export class GetProposalReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProposalReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProposalReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProposalReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProposalReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ProposalReviewView review = 1;
   */ _define_property(this, "review", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.ProposalReviewMaterialView materials = 2;
   */ _define_property(this, "materials", []), /**
   * @generated from field: repeated mono.projectdata.v1.ProposalReviewFindingView findings = 3;
   */ _define_property(this, "findings", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProposalReviewResponse, "runtime", proto3);
_define_property(GetProposalReviewResponse, "typeName", "mono.projectdata.v1.GetProposalReviewResponse");
_define_property(GetProposalReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "review",
            kind: "message",
            T: ProposalReviewView
        },
        {
            no: 2,
            name: "materials",
            kind: "message",
            T: ProposalReviewMaterialView,
            repeated: true
        },
        {
            no: 3,
            name: "findings",
            kind: "message",
            T: ProposalReviewFindingView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateProposalReviewRequest
 */ export class CreateProposalReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateProposalReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProposalReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProposalReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProposalReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: mono.projectdata.v1.ProposalReviewFields fields = 2;
   */ _define_property(this, "fields", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProposalReviewRequest, "runtime", proto3);
_define_property(CreateProposalReviewRequest, "typeName", "mono.projectdata.v1.CreateProposalReviewRequest");
_define_property(CreateProposalReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "fields",
            kind: "message",
            T: ProposalReviewFields
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateProposalReviewResponse
 */ export class CreateProposalReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateProposalReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProposalReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProposalReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProposalReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ProposalReviewView review = 1;
   */ _define_property(this, "review", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProposalReviewResponse, "runtime", proto3);
_define_property(CreateProposalReviewResponse, "typeName", "mono.projectdata.v1.CreateProposalReviewResponse");
_define_property(CreateProposalReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "review",
            kind: "message",
            T: ProposalReviewView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateProposalReviewRequest
 */ export class UpdateProposalReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProposalReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProposalReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProposalReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProposalReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string review_id = 2;
   */ _define_property(this, "reviewId", ""), /**
   * @generated from field: mono.projectdata.v1.ProposalReviewFields fields = 3;
   */ _define_property(this, "fields", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProposalReviewRequest, "runtime", proto3);
_define_property(UpdateProposalReviewRequest, "typeName", "mono.projectdata.v1.UpdateProposalReviewRequest");
_define_property(UpdateProposalReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "fields",
            kind: "message",
            T: ProposalReviewFields
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateProposalReviewResponse
 */ export class UpdateProposalReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProposalReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProposalReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProposalReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProposalReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ProposalReviewView review = 1;
   */ _define_property(this, "review", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProposalReviewResponse, "runtime", proto3);
_define_property(UpdateProposalReviewResponse, "typeName", "mono.projectdata.v1.UpdateProposalReviewResponse");
_define_property(UpdateProposalReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "review",
            kind: "message",
            T: ProposalReviewView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PinReviewMaterialsRequest
 */ export class PinReviewMaterialsRequest extends Message {
    static fromBinary(bytes, options) {
        return new PinReviewMaterialsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PinReviewMaterialsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PinReviewMaterialsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PinReviewMaterialsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string review_id = 2;
   */ _define_property(this, "reviewId", ""), /**
   * @generated from field: repeated string section_ids = 3;
   */ _define_property(this, "sectionIds", []), /**
   * comment is recorded on each snapshot (section_versions.comment); optional.
   *
   * @generated from field: string comment = 4;
   */ _define_property(this, "comment", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PinReviewMaterialsRequest, "runtime", proto3);
_define_property(PinReviewMaterialsRequest, "typeName", "mono.projectdata.v1.PinReviewMaterialsRequest");
_define_property(PinReviewMaterialsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "section_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PinReviewMaterialsResponse
 */ export class PinReviewMaterialsResponse extends Message {
    static fromBinary(bytes, options) {
        return new PinReviewMaterialsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PinReviewMaterialsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PinReviewMaterialsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PinReviewMaterialsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.ProposalReviewMaterialView materials = 1;
   */ _define_property(this, "materials", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PinReviewMaterialsResponse, "runtime", proto3);
_define_property(PinReviewMaterialsResponse, "typeName", "mono.projectdata.v1.PinReviewMaterialsResponse");
_define_property(PinReviewMaterialsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "materials",
            kind: "message",
            T: ProposalReviewMaterialView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AddReviewFindingRequest
 */ export class AddReviewFindingRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddReviewFindingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddReviewFindingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddReviewFindingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddReviewFindingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string review_id = 2;
   */ _define_property(this, "reviewId", ""), /**
   * optional
   *
   * @generated from field: string material_id = 3;
   */ _define_property(this, "materialId", ""), /**
   * empty means note
   *
   * @generated from field: string severity = 4;
   */ _define_property(this, "severity", ""), /**
   * @generated from field: string body = 5;
   */ _define_property(this, "body", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddReviewFindingRequest, "runtime", proto3);
_define_property(AddReviewFindingRequest, "typeName", "mono.projectdata.v1.AddReviewFindingRequest");
_define_property(AddReviewFindingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "material_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "severity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "body",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AddReviewFindingResponse
 */ export class AddReviewFindingResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddReviewFindingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddReviewFindingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddReviewFindingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddReviewFindingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ProposalReviewFindingView finding = 1;
   */ _define_property(this, "finding", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddReviewFindingResponse, "runtime", proto3);
_define_property(AddReviewFindingResponse, "typeName", "mono.projectdata.v1.AddReviewFindingResponse");
_define_property(AddReviewFindingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "finding",
            kind: "message",
            T: ProposalReviewFindingView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CloseProposalReviewRequest
 */ export class CloseProposalReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new CloseProposalReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseProposalReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseProposalReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseProposalReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string review_id = 2;
   */ _define_property(this, "reviewId", ""), /**
   * approved|approved_with_changes|not_approved
   *
   * @generated from field: string outcome = 3;
   */ _define_property(this, "outcome", ""), /**
   * @generated from field: string closure_summary = 4;
   */ _define_property(this, "closureSummary", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseProposalReviewRequest, "runtime", proto3);
_define_property(CloseProposalReviewRequest, "typeName", "mono.projectdata.v1.CloseProposalReviewRequest");
_define_property(CloseProposalReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "outcome",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "closure_summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CloseProposalReviewResponse
 */ export class CloseProposalReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new CloseProposalReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseProposalReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseProposalReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseProposalReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ProposalReviewView review = 1;
   */ _define_property(this, "review", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseProposalReviewResponse, "runtime", proto3);
_define_property(CloseProposalReviewResponse, "typeName", "mono.projectdata.v1.CloseProposalReviewResponse");
_define_property(CloseProposalReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "review",
            kind: "message",
            T: ProposalReviewView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetSectionReviewStatesRequest
 */ export class GetSectionReviewStatesRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetSectionReviewStatesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSectionReviewStatesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSectionReviewStatesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSectionReviewStatesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: repeated string section_ids = 2;
   */ _define_property(this, "sectionIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSectionReviewStatesRequest, "runtime", proto3);
_define_property(GetSectionReviewStatesRequest, "typeName", "mono.projectdata.v1.GetSectionReviewStatesRequest");
_define_property(GetSectionReviewStatesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SectionLastReviewView
 */ export class SectionLastReviewView extends Message {
    static fromBinary(bytes, options) {
        return new SectionLastReviewView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SectionLastReviewView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SectionLastReviewView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SectionLastReviewView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string review_id = 1;
   */ _define_property(this, "reviewId", ""), /**
   * @generated from field: string review_name = 2;
   */ _define_property(this, "reviewName", ""), /**
   * @generated from field: string reviewed_version_id = 3;
   */ _define_property(this, "reviewedVersionId", ""), /**
   * @generated from field: int32 reviewed_version = 4;
   */ _define_property(this, "reviewedVersion", 0), /**
   * @generated from field: string outcome = 5;
   */ _define_property(this, "outcome", ""), /**
   * @generated from field: google.protobuf.Timestamp closed_at = 6;
   */ _define_property(this, "closedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SectionLastReviewView, "runtime", proto3);
_define_property(SectionLastReviewView, "typeName", "mono.projectdata.v1.SectionLastReviewView");
_define_property(SectionLastReviewView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "review_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "reviewed_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reviewed_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "outcome",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "closed_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SectionReviewStateView
 */ export class SectionReviewStateView extends Message {
    static fromBinary(bytes, options) {
        return new SectionReviewStateView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SectionReviewStateView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SectionReviewStateView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SectionReviewStateView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string section_id = 1;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string head_version_id = 2;
   */ _define_property(this, "headVersionId", ""), /**
   * @generated from field: int32 head_version = 3;
   */ _define_property(this, "headVersion", 0), /**
   * approved | approved_with_changes | not_approved | in_review | not_reviewed
   *
   * @generated from field: string state = 4;
   */ _define_property(this, "state", ""), /**
   * @generated from field: mono.projectdata.v1.SectionLastReviewView last_review = 5;
   */ _define_property(this, "lastReview", void 0), /**
   * @generated from field: bool changed_since_review = 6;
   */ _define_property(this, "changedSinceReview", false), /**
   * @generated from field: string open_review_id = 7;
   */ _define_property(this, "openReviewId", ""), /**
   * @generated from field: string open_review_name = 8;
   */ _define_property(this, "openReviewName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SectionReviewStateView, "runtime", proto3);
_define_property(SectionReviewStateView, "typeName", "mono.projectdata.v1.SectionReviewStateView");
_define_property(SectionReviewStateView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "head_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "head_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "last_review",
            kind: "message",
            T: SectionLastReviewView
        },
        {
            no: 6,
            name: "changed_since_review",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "open_review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "open_review_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetSectionReviewStatesResponse
 */ export class GetSectionReviewStatesResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetSectionReviewStatesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSectionReviewStatesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSectionReviewStatesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSectionReviewStatesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.SectionReviewStateView states = 1;
   */ _define_property(this, "states", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSectionReviewStatesResponse, "runtime", proto3);
_define_property(GetSectionReviewStatesResponse, "typeName", "mono.projectdata.v1.GetSectionReviewStatesResponse");
_define_property(GetSectionReviewStatesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "states",
            kind: "message",
            T: SectionReviewStateView,
            repeated: true
        }
    ]));
